// ----------------------------------------------------------------------
// <copyright file="Izenda.SettingsByRange.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var m = require('mobx');
  var constants = require('logic/data/Izenda.SettingsByRangeConstants');
  var VALUE_TYPES = constants.VALUE_TYPES;
  var DATA_TYPE = constants.DATA_TYPE;
  const { isEmpty, last, clone, isNil, uniq, getOr, find, uniqueId } = require('lodash/fp');

  function SettingsByRange() {
    var props = {
      selectedValueType: 'value',
      settingsValue: {
        value: [],
        rangeValue: [],
        rangePercent: []
      },
      editMode: false
    };

    m.extendObservable(this, props);
  }

  SettingsByRange.prototype.setSettingValue = function(settingsValue) {
    settingsValue = settingsValue || {};
    setValueByType = setValueByType.bind(this);

    setValueByType('none');
    setValueByType('value');
    setValueByType('rangeValue');
    setValueByType('rangePercent');

    function setValueByType(valueType) {
      if (settingsValue[valueType]) {
        this.settingsValue[valueType] = m.toJS(settingsValue[valueType]);
        this.selectedValueType = valueType;
        this.editMode = true;
      } else {
        this.settingsValue[valueType] = [];
      }
    }
  };

  /**
   * Only get the current selected setting value
   * @returns {*}
   */
  SettingsByRange.prototype.getSettingValue = function() {
    var result = {};
    var selectedValue = this.selectedValueType;

    this.removeUnSelectSettingValue();
    result[selectedValue] = m.toJS(this.settingsValue[selectedValue]);

    if (isEmpty(result.rangeValue)) {
      result.rangeValue = null;
    }

    if (isEmpty(result.rangePercent)) {
      result.rangePercent = null;
    }

    if (isEmpty(result[selectedValue])) {
      result[selectedValue] = null;
    }
    return result;
  };

  SettingsByRange.prototype.removeUnSelectSettingValue = m.action(function() {
    var selectedValue = this.selectedValueType;
    var backupValue = this.settingsValue[selectedValue];

    this.settingsValue.value = [];
    this.settingsValue.rangeValue = [];
    this.settingsValue.rangePercent = [];
    this.settingsValue[selectedValue] = backupValue;
    this.removeEmptySettingValue();
  });

  /**
   * Remove empty setting value rows
   */
  SettingsByRange.prototype.removeEmptySettingValue = m.action(function(shouldCheckName) {
    var selectedValue = this.selectedValueType;

    this.settingsValue[selectedValue] = this.settingsValue[selectedValue].filter(function(item) {
      if (selectedValue === 'value') {
        return !!item.key || !!item.text;
      } else {
        return shouldCheckName
          ? !!item.from || !!item.to || !!item.text || !!item.name
          : !!item.from || !!item.to || !!item.text;
      }
    });
  });

  /**
   * Check a Row whether it have un-complete value which lack of from - to - name value
   * @param {boolean} shouldCheckName
   * @returns {boolean}
   */
  SettingsByRange.prototype.isExistsUncompleteRangeValue = function(shouldCheckName) {
    var selectedValue = this.selectedValueType;

    function haveData(value) {
      return !!(value || value === 0);
    }

    if (selectedValue !== 'value') {
      var rangeValue = find(function(item) {
        var isThisRowUnComplete = false;

        if (shouldCheckName) {
          // logical xor
          if (!(haveData(item.from) === haveData(item.to) && haveData(item.to) === haveData(item.name))) {
            isThisRowUnComplete = true;
          }
        } else {
          // logical xor
          if (!(haveData(item.from) === haveData(item.to))) {
            isThisRowUnComplete = true;
          }
        }
        return isThisRowUnComplete;
      }, this.settingsValue[selectedValue]);

      return !!rangeValue;
    }
    return false;
  };

  /**
   * Check constrains
   * It have checking duplication of value or range value
   * @returns {Array}
   */
  SettingsByRange.prototype.checkConstrains = function(dataType, cycle) {
    var selectedValue = this.selectedValueType;
    var list = this.settingsValue[selectedValue];
    var i = 0;
    var j = 0;
    var duplicate = [];
    var invalidRange = [];
    var invalidIndex = {};
    var duplicateIndex = {};

    function checkDuplicateValue() {
      for (; i <= list.length - 1; i++) {
        if (!isNil(duplicateIndex[i])) {
          continue;
        }

        for (j = i + 1; j <= list.length - 1; j++) {
          if (!isNil(duplicateIndex[j])) {
            continue;
          }

          if (list[i].key === list[j].key) {
            duplicate.push(list[j]);
            duplicateIndex[j] = j;
            if (isNil(duplicateIndex[i])) {
              duplicate.push(list[i]);
              duplicateIndex[i] = i;
            }
          }
        }
      }
    }

    function registerInvalidRange(index) {
      if (isNil(invalidIndex[index])) {
        invalidRange.push(list[index]);
        invalidIndex[index] = list[index];
      }
    }

    function checkRangeOverlapCycle(firstValue, secondValue) {
      return (
        firstValue.from > firstValue.to &&
        (secondValue.from > firstValue.from ||
          secondValue.to > firstValue.from ||
          secondValue.from < firstValue.to ||
          secondValue.to < firstValue.to)
      );
    }

    function checkDuplicateRangeValue() {
      if (!cycle) {
        for (; i <= list.length - 1; i++) {
          if (list[i].from >= list[i].to) {
            registerInvalidRange(i);
            continue;
          }
          for (j = i + 1; j <= list.length - 1; j++) {
            if (list[j].from >= list[j].to) {
              registerInvalidRange(j);
              continue;
            }
            list[j].from < list[i].to && list[i].from < list[j].to && duplicate.push(list[i], list[j]);
          }
        }
      } else {
        for (; i <= list.length - 1; i++) {
          for (j = i + 1; j <= list.length - 1; j++) {
            if (
              checkRangeOverlapCycle(list[i], list[j]) ||
              checkRangeOverlapCycle(list[j], list[i]) ||
              (list[i].from < list[i].to &&
                list[j].from < list[j].to &&
                list[j].from < list[i].to &&
                list[i].from < list[j].to)
            ) {
              duplicate.push(list[i], list[j]);
            }
          }
        }
      }
    }

    if (selectedValue === 'value') {
      checkDuplicateValue();
    } else {
      checkDuplicateRangeValue();
    }
    duplicate = uniq(duplicate);
    return {
      duplicate: duplicate,
      invalidRange: invalidRange
    };
  };

  SettingsByRange.prototype.checkDuplicateName = function() {
    var selectedValue = this.selectedValueType;
    var list = this.settingsValue[selectedValue];
    var duplicate = [];

    for (var i = 0; i <= list.length - 2; i++) {
      for (var j = i + 1; j <= list.length - 1; j++) {
        list[i].name === list[j].name && duplicate.push(list[i], list[j]);
      }
    }
    return duplicate;
  };

  SettingsByRange.prototype.setValueType = function(valueType) {
    this.selectedValueType = valueType;
  };

  SettingsByRange.prototype.setValueTypeByDataType = function(dataType, dateTimeFormatData) {
    // Only set default value for add new
    if (!this.editMode) {
      switch (dataType) {
        case DATA_TYPE.TEXT:
          this.setValueType('value');
          break;
        case DATA_TYPE.MONEY:
        case DATA_TYPE.NUMERIC:
        case DATA_TYPE.TIME:
          this.setValueType('rangeValue');
          break;
        case DATA_TYPE.DATETIME:
          var settingsValueType = getOr(
            ['value', 'rangeValue'],
            'settingByGroupBy.SETTINGS_VALUE_TYPE',
            dateTimeFormatData
          );

          this.setValueType(last(settingsValueType));
          break;
        case 'none':
          this.setValueType('none');
          break;
        default:
          this.setValueType('value');
      }
    }
  };

  SettingsByRange.prototype.addNewSetting = function(data) {
    var valueType = this.selectedValueType;

    if (data) {
      this.settingsValue[valueType].unshift(clone(data));
      return;
    }
    var valueTypeDef = VALUE_TYPES[valueType] || {};

    valueTypeDef.dataStructure.id = uniqueId('setting_');
    this.settingsValue[valueType].unshift(clone(valueTypeDef.dataStructure || {}));
  };

  module.exports = SettingsByRange;
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.SettingsByRange.js